import { EntityType } from '@frontend/common';
import { PackageClient } from '@frontend/package/api';
import { Package } from '@frontend/package/types';
import { useReactiveObject, useResolver } from '@frontend/repository';
import { Action, ThunkDispatch } from '@reduxjs/toolkit';
import React from 'react';

declare global {
    interface WindowEventMap {
        'usePackage:request': CustomEvent<string>;
    }
}

const REQUEST_PACKAGE_EVENT = 'usePackage:request';
const STORAGE_KEY = 'PKG_REQ';

export function packageRequest(packageId: string): string {
    window.dispatchEvent(new CustomEvent(REQUEST_PACKAGE_EVENT, { detail: packageId }));
    return STORAGE_KEY + '_loading';
}

interface Props {
    dispatch: ThunkDispatch<any, any, Action>;
}

export function PackageResolver(props: Props) {
    useResolver(STORAGE_KEY, REQUEST_PACKAGE_EVENT, EntityType.PACKAGE, (ids) => PackageClient.resolvePackages(ids), props.dispatch);
    return <></>;
}

interface UsePackageResolverProps {
    packageId?: string;
    fetchOnload?: boolean;
}
interface UsePackageResolverReturn {
    package: Package | null;
    initialising: boolean;
    isLoading: boolean;
}

/**
 * @description PackageResolver must be present in the app for this to work.
 */
export function useReactivePackage({ packageId, fetchOnload = false }: UsePackageResolverProps): UsePackageResolverReturn {
    const { object: pkg, initialising, isLoading } = useReactiveObject<Package>({ id: packageId, entity_type: EntityType.PACKAGE, fetchOnload, resolveFunction: packageRequest });
    return { package: pkg, initialising, isLoading };
}
